import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { Box as s, Anchor as t, Group as h } from "@mantine/core";
import "../ProductTileSkeleton.js";
import { Rating as l } from "../../Rating/index.js";
const n = ({ average: e, count: r, productLink: m }) => i(s, { mb: { base: "lg", md: "xl" }, children: [!r && o(t, { href: `${m}#reviews`, children: "Leave the first review" }), !!r && i(h, { children: [o(l, { value: e }), e.toFixed(1), " (", r, ")"] })] });
export {
  n as Reviews
};
